module.exports = __webpack_public_path__ + "static/img/invest-consume12.1e61fb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-consume12.jpg
// module id = LMtj
// module chunks = 0